/*
 * MOVOQO — site-wide interactions.
 * - Intercepts any <form action="/cart/add"> (movoqo.liquid shop block, main-product.liquid)
 *   and adds via /cart/add.js instead of a full page POST, then opens the cart drawer.
 * - Cart drawer quantity/remove go through /cart/change.js.
 * - After any mutation, re-renders the cart-drawer and header sections via the
 *   Sections Rendering API so counts/totals/lines stay in sync with the real Shopify cart.
 * - Falls back to a native form submit if the fetch fails, so Add to cart still works without JS.
 * - Also handles the header's mobile nav toggle.
 */
(function(){
  function closest(el, sel){ return el && el.closest ? el.closest(sel) : null; }

  // Announcement bar: stays dismissed for the rest of the browsing session
  var announcementBar = document.querySelector('.announcement-bar');
  if(announcementBar){
    try {
      if(sessionStorage.getItem('movoqo:announcementDismissed') === '1'){
        announcementBar.style.display = 'none';
      }
    } catch(e){}
  }

  function openDrawer(){
    var d = document.getElementById('cart-drawer');
    if(!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-locked');
  }

  function closeDrawer(){
    var d = document.getElementById('cart-drawer');
    if(!d) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-locked');
  }

  function swapSection(id, html){
    var wrapperId = 'shopify-section-' + id;
    var current = document.getElementById(wrapperId);
    if(!current || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#' + wrapperId) || tmp.firstElementChild;
    if(fresh) current.innerHTML = fresh.innerHTML;
  }

  function refreshCartSections(){
    return fetch(window.location.pathname + '?sections=cart-drawer,header')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var existing = document.getElementById('cart-drawer');
        var wasOpen = !!(existing && existing.classList.contains('open'));
        swapSection('cart-drawer', data['cart-drawer']);
        swapSection('header', data['header']);
        if(wasOpen) openDrawer();
      });
  }

  function postCartAdd(opts){
    return fetch('/cart/add.js', opts)
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(res && res.status){ return Promise.reject(res); }
        return refreshCartSections();
      });
  }

  // Free-gift products (see sections/main-product.liquid "Free gift" blocks) are added
  // in the same /cart/add.js call as the main item, via Shopify's multi-item `items` array,
  // so both land in the cart atomically from a single Add to cart click.
  function addToCart(form){
    var giftInput = form.querySelector('.mp-gift-variants');
    var giftIds = giftInput && giftInput.value
      ? giftInput.value.split(',').map(function(s){ return s.trim(); }).filter(Boolean)
      : [];

    var request;
    if(giftIds.length){
      var formData = new FormData(form);
      var items = [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity'), 10) || 1 }];
      giftIds.forEach(function(id){ items.push({ id: id, quantity: 1 }); });
      request = postCartAdd({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    } else {
      request = postCartAdd({
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });
    }

    return request.then(openDrawer).catch(function(){ form.submit(); });
  }

  function changeLine(line, quantity){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function(r){ return r.json(); })
      .then(refreshCartSections);
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(form.tagName === 'FORM'){
      var action = form.getAttribute('action') || '';
      if(action.indexOf('/cart/add') !== -1){
        e.preventDefault();
        addToCart(form);
      }
    }
  });

  document.addEventListener('click', function(e){
    if(closest(e.target, '[data-cart-drawer-open]')){ e.preventDefault(); openDrawer(); return; }
    if(closest(e.target, '[data-cart-drawer-close]')){ closeDrawer(); return; }

    var announcementClose = closest(e.target, '[data-announcement-close]');
    if(announcementClose){
      var bar = closest(announcementClose, '.announcement-bar');
      if(bar) bar.style.display = 'none';
      try { sessionStorage.setItem('movoqo:announcementDismissed', '1'); } catch(err){}
      return;
    }

    var navToggle = closest(e.target, '[data-nav-toggle]');
    if(navToggle){
      var nav = document.getElementById(navToggle.getAttribute('aria-controls'));
      if(nav){
        var open = nav.classList.toggle('open');
        navToggle.setAttribute('aria-expanded', open);
      }
      return;
    }

    var line = closest(e.target, '[data-line]');
    if(line){
      var lineIndex = parseInt(line.getAttribute('data-line'), 10);
      var qtyEl = line.querySelector('.cd-qty span');
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if(closest(e.target, '[data-cart-qty-plus]')){ changeLine(lineIndex, currentQty + 1); return; }
      if(closest(e.target, '[data-cart-qty-minus]')){ changeLine(lineIndex, Math.max(0, currentQty - 1)); return; }
      if(closest(e.target, '[data-cart-remove]')){ changeLine(lineIndex, 0); return; }
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeDrawer();
  });
})();
